import { useContext, useEffect, useState } from 'react'
import DataTable from "../../../../components/userAdminPanel/Components/UserDataTable/DataTable";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import newRequest from "../../../../utils/newRequest";
import Swal from 'sweetalert2';
import Addfootermenu from './Addfootermenu';
import Updatefootermenu from './Updatefootermenu';
import { useTranslation } from 'react-i18next';
import CustomSnakebar from '../../../../utils/CustomSnakebar';
import { footerMenuDataColumn } from '../../../../datatablesource';
const Footermenu = () => {

    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
    const [isCreatePopupVisible, setCreatePopupVisibility] = useState(false);
    const [brandsData, setBrandsData] = useState([]);
    const handleShowCreatePopup = () => {
        setCreatePopupVisibility(true);
    };

    const [isUpdatePopupVisible, setUpdatePopupVisibility] = useState(false);

    const handleShowUpdatePopup = (row) => {
        setUpdatePopupVisibility(true);
        // save this row data in session storage 
        sessionStorage.setItem("updatefootermenu", JSON.stringify(row));
    };
    const [filteredData, setFilteredData] = useState([]);

    const refreshcitiesData = async () => {
        try {
            const response = await newRequest.get("/getAllfooter_menus",);
            setData(response?.data || []);
            setIsLoading(false)
            const citiesData = response?.data || [];

            const statesResponse = await newRequest.get('/getAllmega_menu_categories');
            const statesData = statesResponse?.data || [];
            const stateIdToNameMap = {};
            statesData.forEach(state => {
                stateIdToNameMap[state.id] = state.category_name_en;
            });


            const updatedCitiesData = citiesData.map(megnumenu => ({
                ...megnumenu,
                parent_id: stateIdToNameMap[megnumenu.parent_id] || "Unknown Category",
            }));
            setData(updatedCitiesData);
            // console.log('getAllmega_menu_categories', updatedCitiesData);

        } catch (err) {
            console.log('_____',err);
            setIsLoading(false)
        }
    };
    useEffect(() => {

        refreshcitiesData() // Calling the function within useEffect, not inside itself
    }, []);
    const handleDelete = async (row) => {
        Swal.fire({
            title: `${t('Are you sure to delete this record?')}!`,
            text: `${t('You will not be able to recover this')} ${t('Footer menu')}!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: `${t('Yes')} , ${t('Delete')}!`,
            cancelButtonText: `${t('No, keep it')}!`,
            // changes the color of the confirm button to red
            confirmButtonColor: '#1E3B8B',
            cancelButtonColor: '#FF0032',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const isDeleted = await newRequest.delete("/deletefooter_menus/" + row?.id);
                    if (isDeleted) {
                        setMessage(`${t('Footer menu')}  ${t('has been deleted')} ${t('successfully')}!`)
                        const filteredData = brandsData.filter((item) => item?.id !== row?.id);
                        setBrandsData(filteredData);
                        refreshcitiesData()
                    } else {
                        // Handle any additional logic if the user was not deleted successfully
                        setError("Failed to delete user");
                    }
                } catch (error) {
                    // Handle any error that occurred during the deletion
                    console.error("Error deleting user:", error);
                    setError(`${t('Footer menu')} {t('has been not deleted')} ${t('Delete')}!`);
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                return;
            }
        });
    };
    const handleRowClickInParent = (item) => {
        if (!item || item?.length === 0) {
            // setTableSelectedRows(data)
            setFilteredData(data)
            return
        }

    }
     const resetSnakeBarMessages = () => {
       setError(null);
       setMessage(null);
     };
    return (
        <div>
            <div className={`p-0 h-full`}>
                 {message && (
            <CustomSnakebar
              message={message}
              severity="success"
              onClose={resetSnakeBarMessages}
            />
          )}
          {error && (
            <CustomSnakebar
              message={error}
              severity="error"
              onClose={resetSnakeBarMessages}
            />
          )}

                <div className='flex justify-center items-center'>
                    <div className="h-auto w-[97%] px-0 pt-4">
                        <div className="h-auto w-full p-0 bg-white shadow-xl rounded-md">

                            <div className={`flex  sm:justify-start items-center flex-wrap gap-2 py-7 px-3 ${i18n.language === 'ar' ? 'flex-row-reverse justify-start' : 'flex-row justify-start'}`}>
                                <button
                                    onClick={handleShowCreatePopup}
                                    className="rounded-full bg-secondary font-body px-5 py-1 text-sm mb-3 text-white transition duration-200 hover:bg-primary">
                                    <i className="fas fa-plus mr-2"></i>{t('Add')}
                                </button>
                              
                            </div>
                            {/* DataGrid */}
                            <div style={{ marginLeft: '-11px', marginRight: '-11px' }}>

                                <DataTable data={data}
                                    title={`${t('Footer menu')}`}
                                    columnsName={footerMenuDataColumn(t)}
                                    loading={isLoading}
                                    secondaryColor="secondary"
                                    handleRowClickInParent={handleRowClickInParent}

                                    dropDownOptions={[
                                        {
                                            label: `${t('Edit')}`,
                                            icon: (
                                                <EditIcon
                                                    fontSize="small"
                                                    color="action"
                                                    style={{ color: "rgb(37 99 235)" }}
                                                />
                                            ),
                                            action: handleShowUpdatePopup,
                                        },
                                        {
                                            label: `${t('Delete')}`,
                                            icon: (
                                                <DeleteIcon
                                                    fontSize="small"
                                                    color="action"
                                                    style={{ color: "rgb(37 99 235)" }}
                                                />
                                            ),
                                            action: handleDelete,
                                        },

                                    ]}
                                    uniqueId="gtinMainTableId"

                                />
                            </div>

                        </div>
                    </div>
                </div>

                {/* Addunit component with handleShowCreatePopup prop */}
                 {isCreatePopupVisible && (
                    <Addfootermenu isVisible={isCreatePopupVisible} setVisibility={setCreatePopupVisibility} refreshBrandData={refreshcitiesData} />
                )}
                {/* Updateunit component with handleShowUpdatePopup prop */}
                {isUpdatePopupVisible && (
                    <Updatefootermenu isVisible={isUpdatePopupVisible} setVisibility={setUpdatePopupVisibility} refreshBrandData={refreshcitiesData} />
                )}

            </div>
        </div>
    )
}

export default Footermenu